import React from 'react';
import { AccountFieldProps } from './types';
import { styles } from './styles';

const AccountField: React.FC<AccountFieldProps> = ({ label, children, className }) => {
  return (
    <div className={className}>
      <label className={styles.label}>{label}</label>
      <div className={styles.value}>{children}</div>
    </div>
  );
};

export default AccountField;
